export default "__VITE_ASSET__By6hVG$C__"